// Clicking a cue's number, label or time on the page swaps the text for an input
// and focuses it a moment later, so the browser never sees where you clicked and
// the cursor landed at the end (Josh, 11 Oct 2026: "clunky"). These helpers read
// the clicked letter before the swap so the input can put the cursor there.

export function eventPoint(e) {
    if (!e) return null;
    const touch = (e.touches && e.touches[0]) || (e.changedTouches && e.changedTouches[0]);
    const src = touch || e;
    if (typeof src.clientX !== 'number' || typeof src.clientY !== 'number') return null;
    return { x: src.clientX, y: src.clientY };
}

// The character offset under (x, y) within el's visible text, or null when the
// point isn't on el's own text. The template's indentation around the text is
// not part of the value, so it is not counted.
export function caretOffsetAt(el, x, y, doc) {
    if (!el || !doc) return null;
    let node = null;
    let offset = 0;
    if (typeof doc.caretPositionFromPoint === 'function') {
        const pos = doc.caretPositionFromPoint(x, y);
        if (pos) {
            node = pos.offsetNode;
            offset = pos.offset;
        }
    } else if (typeof doc.caretRangeFromPoint === 'function') {
        const range = doc.caretRangeFromPoint(x, y);
        if (range) {
            node = range.startContainer;
            offset = range.startOffset;
        }
    }
    if (!node || node.nodeType !== 3 || node.parentNode !== el) return null;
    const text = node.textContent || '';
    const lead = text.length - text.replace(/^\s+/, '').length;
    const visible = text.trim().length;
    return Math.max(0, Math.min(offset - lead, visible));
}

// The word (run of non-space characters) touching offset, as [start, end].
export function wordBounds(value, offset) {
    const text = String(value || '');
    const at = Math.max(0, Math.min(offset, text.length));
    let start = at;
    let end = at;
    while (start > 0 && !/\s/.test(text[start - 1])) start -= 1;
    while (end < text.length && !/\s/.test(text[end])) end += 1;
    return [start, end];
}


// WEBPACK FOOTER //
// ./src/lib/cue-caret.js